module.exports = {
  APP_STRAPI_URL: 'https://cms.cmccloud.vn/',
  APP_STRAPI_TOKEN:
    '59544943dbaa35774de9fde2ce7f4b99baa97a15618b061216df985572ffbc097089beaf23b51be37e2e84ec1511c10c3' +
    '3d7ee6b0e28bd114620a93b0a7445e9ec6a43c113162c7ed63bd2558470de40140ef31a32079d2855f2eed1b6fd58b406' +
    '3457c11f72911bcf592aa0bb6230d99a0b8d1e02efffbb1adf7d410ab7d010',
  APP_SIGN_IN_URL: 'https://portalv2.cloud.cmctelecom.vn/',
  APP_REGISTER_ACCOUNT_URL: 'https://portalv2.cloud.cmctelecom.vn/auth/register',
  APP_GOOGLE_MAP_API_KEY: 'AIzaSyC4ClTvLKoOketleEegcYTpJ2h5MCFHfOQ',
};
